import React from 'react';

import { formatCurrency, formatDate, useTextColor } from '@/Utils/helpers';
import { BillingHistoryItem } from '@/Utils/stripeHooks/usePaymentHistory';

type Props = {
  history: BillingHistoryItem;
};

const BillingHistoryCard: React.FC<Props> = ({ history }) => {
  const {
    date,
    description,
    amount,
    invoice_url,
    status,
    invoice_lines,
    use_invoice_lines,
  } = history;
  const textColor = useTextColor(status);

  return (
    <>
      {use_invoice_lines ? (
        invoice_lines.map((invoice_line) => (
          <a
            key={invoice_line.id}
            href={invoice_url}
            target='_blank'
            rel='noopener noreferrer'
            className='grid grid-cols-resp-auto-2 sm:grid-cols-resp-histiry justify-between gap-x-8 sm:gap-4 border-0 border-b border-customBorder border-solid py-5 text-14px md:text-16px md:hover:bg-bodyBg transition duration-200 px-10'
          >
            <span className='text-customBlack'>
              {formatDate(new Date(date))}
            </span>
            <span
              className={`capitalize  text-right sm:text-left ${textColor}`}
            >
              {status}
            </span>
            <span className='text-customBlack'>{invoice_line.description}</span>
            <span
              className='text-customBlack justify-self-end text-right'
              style={{ minWidth: '90px' }}
            >
              {formatCurrency(invoice_line.amount)}
            </span>
          </a>
        ))
      ) : (
        <a
          href={invoice_url}
          target='_blank'
          rel='noopener noreferrer'
          className='grid grid-cols-resp-auto-2 sm:grid-cols-resp-histiry justify-between gap-x-8 sm:gap-4 border-0 border-b border-customBorder border-solid py-5 text-14px md:text-16px md:hover:bg-bodyBg transition duration-200 px-10'
        >
          <span className='text-customBlack'>{formatDate(new Date(date))}</span>
          <span className={`capitalize text-right sm:text-left ${textColor}`}>
            {status}
          </span>
          <span className='text-customBlack'>{description}</span>
          <span
            className='text-customBlack justify-self-end text-right'
            style={{ minWidth: '90px' }}
          >
            {formatCurrency(amount)}
          </span>
        </a>
      )}
    </>
  );
};

export default BillingHistoryCard;
